module.exports = __webpack_public_path__ + "img/verified.4623577c.svg";